import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  lastUpdatedLabel: {
    id: 'frontbucket.repository.pullrequest.forge-merge-check-item-popup.lastUpdatedLabel',
    description:
      'Label for showing the last updated time of the merge check result',
    defaultMessage: 'Last updated {relativeTime}',
  },
  noUpdatesLabel: {
    id: 'frontbucket.repository.pullrequest.forge-merge-check-item-popup.noUpdatesLabel',
    description:
      'Label for showing that there are no updates for the merge check result',
    defaultMessage: 'No updates yet',
  },
  didNotPassLabel: {
    id: 'frontbucket.repository.pullrequest.forge-merge-check-item-popup.didNotPassLabel',
    description: 'Lozenge label for a failed result',
    defaultMessage: 'Did not pass',
  },
  passedLabel: {
    id: 'frontbucket.repository.pullrequest.forge-merge-check-item-popup.passedLabel',
    description: 'Lozenge label for a success result',
    defaultMessage: 'Passed',
  },
  waitingToRunLabel: {
    id: 'frontbucket.repository.pullrequest.forge-merge-check-item-popup.waitingToRunLabel',
    description: 'Label for a check that is waiting to run',
    defaultMessage: 'Waiting to run',
  },
  recommendedCheckLabel: {
    id: 'frontbucket.repository.pullrequest.forge-merge-check-item-popup.recommendedCheckLabel',
    description: 'Label for a recommended check',
    defaultMessage: 'This is a recommended check and does not affect merging.',
  },
});
